module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("G. K. Chesterton’s fictional detective,"), _c('br'), _vm._v("Father Brown, posed two riddles.")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("Where would a wise man hide a leaf?"), _c('br'), _vm._v("In the forest.")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("Where would a wise man hide a body?"), _c('br'), _vm._v("On a battlefield.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 75
// module chunks = 0